"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelBookingOrder = void 0;
class CancelBookingOrder {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.cancelBookingOrder(request);
    }
}
exports.CancelBookingOrder = CancelBookingOrder;
